import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "@/lib/api";
import { Target, ArrowRight } from "@phosphor-icons/react";
import { Progress } from "@/components/ui/progress";

const ACTIVE = ["active", "urgent", "partially_funded"];

// Compact "your institution needs help" strip for an alumni group page.
export default function GroupInstitutionNeeds({ institutionId, institutionName }) {
  const [projects, setProjects] = useState([]);
  useEffect(() => {
    if (!institutionId) return;
    api.get(`/institutions/${institutionId}/projects`).then((r) => setProjects((r.data || []).filter((p) => ACTIVE.includes(p.status)))).catch(() => {});
  }, [institutionId]);

  if (!institutionId || projects.length === 0) return null;
  return (
    <div className="mt-4 rounded-2xl border border-secondary/20 bg-gradient-to-br from-green-50/60 to-orange-50/30 p-4" data-testid="group-institution-needs">
      <div className="flex items-center gap-2">
        <Target size={18} weight="duotone" className="text-secondary" />
        <h3 className="font-heading text-lg font-medium">{institutionName ? `${institutionName} needs your help` : "Your institution needs help"}</h3>
      </div>
      <div className="mt-3 grid gap-2 sm:grid-cols-2">
        {projects.slice(0, 4).map((p) => (
          <Link key={p.id} to={`/projects/${p.id}`} className="block rounded-xl border border-border/60 bg-white p-3 hover:border-secondary/50" data-testid={`group-need-${p.id}`}>
            <div className="flex items-center justify-between gap-2">
              <span className="truncate text-sm font-medium">{p.title}</span>
              {p.status === "urgent" && <span className="shrink-0 text-xs text-red-600">🔴 Urgent</span>}
            </div>
            {p.funding_goal > 0 && <Progress value={p.funded_pct} className="mt-2 h-1.5" />}
          </Link>
        ))}
      </div>
      <Link to={`/institutions/${institutionId}`} className="mt-2 inline-flex items-center gap-1 text-sm text-secondary hover:underline">
        See all ways to help <ArrowRight size={14} />
      </Link>
    </div>
  );
}
